import { Base } from "ui/Scripts/source/framework/base";
import { DocumentTemplateListItem, IDocumentTemplateListItem } from "../documentTemplate/documentTemplateListItem";

export interface IDocumentDocumentNew {
    items: IDocumentTemplateListItem[];
}

export class DocumentDocumentNew implements IDocumentDocumentNew {
    items: DocumentTemplateListItem[];

    constructor();
    constructor(obj: IDocumentDocumentNew);
    constructor(obj?: any) {
        this.items = Base.getTypedArray(obj ? obj.items : null, DocumentTemplateListItem);
    }
}